<ul [class]="listType ? (indent ? 'pl-3 ' : 'pl-0') + 'border border-light rounded' : indent ? '' : 'pl-0'" style="list-style-type: none">
  <li class="cursor-pointer" [ngClass]="{ 'd-none': documentType.hide, 'list-group-item': listType }" *ngFor="let documentType of documentTypes">
    <a *ngIf="showExpandChildren" href="javascript: void(0)" (click)="$event.stopPropagation(); $event.preventDefault(); toggleDocumentType(documentType)">
      <i class="fas font-weight-bold text-primary" [ngClass]="{ 'fa-plus-circle': !documentType.expanded, 'fa-minus-circle': documentType.expanded }"></i>
    </a>
    <div *ngIf="!showCheckbox">
      <span class="font-weight-bold">&nbsp;{{ documentType.prefix }} - </span>
      <span [ngClass]="{ 'text-muted': !documentType.is_active }">{{ documentType.name }}</span
      >&nbsp;
      <a href="javascript: void(0)" [ngClass]="{ 'text-secondary': selectedDocumentTypeId == documentType.id }" (click)="$event.stopPropagation(); $event.preventDefault(); selectDocumentType(documentType)">View</a>
    </div>
    <div *ngIf="showCheckbox">
      <div class="custom-control custom-checkbox" (click)="documentType.selected = !documentType.selected; selectDocumentType(documentType)">
        <input type="checkbox" class="custom-control-input" [(ngModel)]="documentType.selected" />
        <label class="custom-control-label">
          <span class="font-weight-bold">&nbsp;{{ documentType.prefix }} - </span>
          <span [ngClass]="{ 'text-muted': !documentType.is_active }">{{ documentType.name }}</span>
        </label>
      </div>
    </div>
    <br *ngIf="documentType.expanded && !showCheckbox" />
    <app-document-type-list
      [listType]="listType"
      [loadChildren]="loadChildren"
      [showCheckbox]="showCheckbox"
      [showExpandChildren]="showExpandChildren"
      *ngIf="documentType.expanded"
      [selectedDocumentTypeId]="selectedDocumentTypeId"
      [updatedDocumentTypeNumber]="updatedDocumentTypeNumber"
      [documentTypes]="documentType.children"
      (selectedDocumentType)="selectDocumentType($event)"
    ></app-document-type-list>
  </li>
</ul>
